import React from "react";

const TemplateTaskItemsContext = React.createContext();

export default TemplateTaskItemsContext;
